import { render, staticRenderFns } from "./WechatCode.vue?vue&type=template&id=1187499c&scoped=true"
import script from "./WechatCode.vue?vue&type=script&lang=js"
export * from "./WechatCode.vue?vue&type=script&lang=js"
import style0 from "./WechatCode.vue?vue&type=style&index=0&id=1187499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187499c",
  null
  
)

export default component.exports